import classNames from "classnames"

import { useTranslation } from "@bounce/i18n"
import { FAQs as BaseFAQs } from "@bounce/web-components"

import type { CityData, PoiData } from "../../../../libs/bounce/types"
import { FAQStructuredData } from "@/components/Generic/StructuredData/StructuredData"
import { useFAQs } from "@/components/LuggageStorage/FAQs/useFAQs"

type Props = {
  className?: string
  place?: Pick<CityData | PoiData, "translatedName" | "slug">
  subtitle?: string
}

export const FAQs = ({ className, place, subtitle }: Props) => {
  const { t } = useTranslation("marketing-ls-store")
  const faqs = useFAQs({ place })

  return (
    <>
      <div className={classNames(className, "mx-auto w-full")} id="faqs">
        <BaseFAQs
          faqs={faqs}
          id="faq"
          title={t("screen.storeScreen.faqs.title", "Frequently asked questions")}
          subtitle={subtitle}
        />
      </div>
      <FAQStructuredData faqs={faqs} />
    </>
  )
}
